import type { ProtoNotification } from "$types";
import { log } from "./logs";
/**
 *
 * @param data
 * @returns
 */
export const create_notification = async (
  data: ProtoNotification,
): Promise<boolean> => {
  log("Creating a new notification").dev("notifications");

  const res = await fetch("/api/notifications/create-notification", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ data }),
  });

  if (res) {
    const response = await res.json();
    if (response.success) {
      return true;
    }
  }

  return false;
};
